// extracted by mini-css-extract-plugin
var _1 = "EBAg4__button";
var _2 = "EBAg4__num";
var _3 = "EBAg4__numContent";
var _4 = "EBAg4__numContent_lost";
var _5 = "EBAg4__numContent_selected";
var _6 = "EBAg4__numContent_won";
var _7 = "EBAg4__tile";
export { _1 as "button", _2 as "num", _3 as "numContent", _4 as "numContent_lost", _5 as "numContent_selected", _6 as "numContent_won", _7 as "tile" }
